import apiClient from "@/api/client";

export default {
  getNotifications(context) {
    apiClient
      .get("notifications")
      .then((res) => {
        context.commit("setNotifications", res.data.data);
        context.commit("setUnread", res.data.unread_count);
      })
      .catch(() => {});
  },
  getUnRead(context) {
    apiClient
      .get("unread-notification-count")
      .then((res) => {
        context.commit("setUnreadMes", res.data.data.unread);
      })
      .catch(() => {});
  },
};
